import React, { Fragment } from 'react';
import { getBackgroundImg, getPublicImagePath } from '@nutastic/nutastic-react-app';

const HomePage = () => {
    const componentClass = 'home-page';

    return <Fragment>
        <section className={`${componentClass}__banner`}>
            <div className="bannerImg animated fadeIn delay-1s" style={getBackgroundImg(getPublicImagePath('markiru-bg.jpg'))} />
            <div className="overlay" />
            <div className="container h-100">
                <div className={`${componentClass}__subtitle isCursive`}>forever-n-love</div>
                <h1 className={`${componentClass}__title-header`}>Nkiru &amp; Marlon</h1>
                <div className={`${componentClass}__subtitle hasBars animated fadeInUp delay-1s`}>08.09.25</div>
                <a href="/public/assets/markiru-program.pdf" className="btn btn-outline-white animated fadeIn delay-1s">Open Wedding Program</a>
            </div>
        </section>
    </Fragment>;
};

export default HomePage;
